export * from "./$__metadata.js";
export * from "./$__needle.types.js"


// TODO: move proxy url to environment config

// Used for AI chat to proxy requests that don't have an AI token (e.g. chrome extension)
export const needleCloudProxy = "https://proxy.needle.run/";


export const needleUserAgent = "Needle Inspector/1.0 (+https://needle.tools/)";


const editorUIElements = new WeakSet<object>();

type ElementWithParent = Element & { parentElement: ElementWithParent | null };
function isElementWithParent(element: HTMLElement | EventTarget | null): element is ElementWithParent {
    return element instanceof Element && "parentElement" in element;
}

export function isNeedleEditorHTMLElement(element: Element | EventTarget | null): boolean {

    if (!element) return false;
    if (editorUIElements.has(element)) return true;
    
    if (!isElementWithParent(element)) {
        return false;
    }

    // console.log("CHECKING ELEMENT:", element, element.id, element.tagName);

    if (element.id === "NEEDLE_EDITOR_ROOT") return true;
    if (element.tagName.startsWith("NEEDLE-EDITOR-")) return true;


    if (element.parentElement) {
        const res = isNeedleEditorHTMLElement(element.parentElement);
        if (res === true) {
            editorUIElements.add(element);
            return true;
        }
    }
    return false

}
